export enum MessageType {
    Info = 'info',
    Success = 'success',
    Error = 'error',
    Warning = 'warning'
}
